<div class="d-flex justify-content-between p-3">
    <div>
        <button class="btn btn-sm btn-primary d-flex align-items-center" >
        <i class="cil-arrow-left custom-icon pe-1"></i>
        Back
        </button>
    </div>
    <div class="d-flex justify-content-between align-items-center py-2">
        <c-button-group class="btn btn-primary" role="group">
          <button cButton class="btn-primary" (click)="handleDoc('pdf')">PDF</button>
          <button cButton class="btn-primary" (click)="handleDoc('csv')">CSV</button>
          <button cButton class="btn-primary" (click)="handleDoc('xls')">XLS</button>
        </c-button-group>
      </div>
</div>
